var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "episode__button-icon",
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 21.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "episode__button-icon__path",
    d: "M30.5 0C24.5666 0 18.7664 1.75947 13.8329 5.05591C8.89943 8.35235 5.05426 13.0377 2.78363 18.5195C0.512999 24.0013 -0.0811016 30.0333 1.07646 35.8527C2.23401 41.6721 5.09124 47.0176 9.28681 51.2132C13.4824 55.4088 18.8279 58.266 24.6473 59.4236C30.4667 60.5811 36.4987 59.987 41.9805 57.7164C47.4623 55.4458 52.1477 51.6006 55.4441 46.6671C58.7405 41.7336 60.5 35.9334 60.5 30C60.5 22.0435 57.3393 14.4129 51.7132 8.7868C46.0871 3.16071 38.4565 0 30.5 0ZM45.7586 29.8862L23.8793 44.4828C23.7242 44.5991 23.5395 44.6696 23.3463 44.6861C23.1531 44.7026 22.9592 44.6644 22.7866 44.576C22.614 44.4875 22.4698 44.3524 22.3704 44.1859C22.2709 44.0194 22.2202 43.8284 22.2242 43.6345V14.4207C22.2232 14.2335 22.2731 14.0496 22.3685 13.8886C22.4639 13.7275 22.6012 13.5954 22.7657 13.5062C22.9303 13.417 23.116 13.3741 23.303 13.3821C23.49 13.3902 23.6713 13.4488 23.8276 13.5517L45.7586 28.169C45.9009 28.2627 46.0179 28.3901 46.0991 28.5399C46.1803 28.6897 46.2233 28.8572 46.2242 29.0276C46.2233 29.198 46.1803 29.3655 46.0991 29.5153C46.0179 29.6651 45.9009 29.7925 45.7586 29.8862Z",
    fill: "#832926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.a81320be1918130c1455d0bdd39d188a.svg";
export { ForwardRef as ReactComponent };